import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function Blueprints() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Blueprints</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Implementation blueprints
            <br />
            for regulated delivery
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Step-by-step execution playbooks: people, process, technology, evidence, cadence.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/offerings" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white hover:opacity-95">
              Explore offerings →
            </Link>
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-2">
            {[ 
              {
                t: "DPDPA compliance blueprint (12-month)",
                d: "Data mapping → consent + DSAR → security hardening → breach readiness → governance + metrics.",
                href: "/frameworks/india/dpdpa#journey",
              },
              {
                t: "RBI program blueprint (12-week)",
                d: "Control implementation with evidence automation, SOC uplift, and audit readiness Check-Points.",
                href: "/frameworks/india/rbi",
              },
              {
                t: "Cross-framework mapping blueprint",
                d: "Normalize control domains across RBI/SEBI/IRDAI/CERT-In and map to ISO/NIST for global reporting.",
                href: "/technology-mapping",
              },
              {
                t: "OT/ICS security blueprint",
                d: "Purdue zones, asset inventory, safe remote access, OT monitoring, and incident response integration.",
                href: "/ot-security",
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5">
                  <Link to={x.href} className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                    Open reference →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Request a blueprint pack</div>
            <div className="mt-3 text-sm text-text-secondary">We can tailor the blueprint to your organization size and tooling.</div>
            <div className="mt-6">
              <ContactForm title="Blueprint request" subtitle="We can turn this into a workshop + execution plan." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
